// extracted by mini-css-extract-plugin
module.exports = {"root":"Select_root__3cLzc","select":"Select_select__QVGL8","default":"Select_default__1ptAq","small":"Select_small__WeQJl","large":"Select_large__3wXKp"};